import React from 'react'

import LtiApplyTheme from './LtiApplyTheme'
import LaunchRetriever from './LaunchRetriever'
import EmojiPicker from "./EmojiPicker";

const settings = {
  'https://localhost:3000': {
    'ltiServer': process.env.REACT_APP_LTI_URL
  },
  'https://emoji-picker.wyelearning.com': {
    'ltiServer': 'https://lti.wyelearning.com'
  }
}

class App extends React.Component {
  state = {
    jwt: null,
    needsToken: false,
    error: null,
    brandConfig: null,
    returnUrl: null,
    highContrast: false,
    data: null,
    css: undefined
  }

  constructor(props) {
    super(props)
    const origin = window.origin
    if (settings[origin]) {
      this.server = settings[origin].ltiServer
    }
  }

  /**
   * Get a LTI parameter from the decoded JWT data. 
   * @param data The decoded JWT data.
   * @param param The parameter to retrieve.
   * @return {*|null} The parameter or null if it's not defined.
   */
  getItem = (data, param) => {
    const array = data[param]
    return (array && array.length > 0)?array[0]:null
  }

  updateData = async (data) => {
    let selection = this.getItem(data, 'custom_selection')
    // If there isn't any selection is sends through the unexpanded variable
    if (selection === '$com.instructure.Editor.selection') {
      selection = ''
    }

    return this.setState({
      brandConfig: this.getItem(data, 'custom_brand_config'),
      highContrast: this.getItem(data, 'custom_high_contrast') === 'true',
      selection: selection,
      returnUrl: this.getItem(data, 'content_item_return_url'),
      data: this.getItem(data, 'data'),
      css: this.getItem(data, 'custom_canvas_css')
    })
  }

  render() {
    return (
        <LaunchRetriever ltiServer={this.server} handleData={this.updateData}>
          <LtiApplyTheme url={this.state.brandConfig} highContrast={this.state.highContrast}>
            <EmojiPicker returnUrl={this.state.returnUrl} data={this.state.data} />
          </LtiApplyTheme>
        </LaunchRetriever>
    )
  }
}

export default App
